import { render, staticRenderFns } from "./SolarPlantSolarPanels.vue?vue&type=template&id=567839bc&scoped=true"
import script from "./SolarPlantSolarPanels.vue?vue&type=script&lang=js"
export * from "./SolarPlantSolarPanels.vue?vue&type=script&lang=js"
import style0 from "./SolarPlantSolarPanels.vue?vue&type=style&index=0&id=567839bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567839bc",
  null
  
)

export default component.exports